import React from 'react';
import NukaCarousel from 'nuka-carousel';
import PropTypes from 'prop-types';
import Pagination from './decorator';

import './marketing-carousel.css';

const Decorators = [
  {
    component: Pagination,
    position: 'BottomCenter',
    marginTop: '50px'
  }];

const MarketingCarousel = props => (
  <NukaCarousel
    className="marketing-carousel"
    decorators={ Decorators }
    wrapAround={ true }
    autoplay={ true }
    autoplayInterval= { 7000 }
  >
    <div className="slide slide-1">
      <div className="slide-copy">
        <h1>Daily workouts</h1>
        <h2>Receive daily workout options that align with your personal preferences, goals, and body type.</h2>
      </div>
    </div>
    <div className="slide slide-2">
      <div className="slide-copy">
        <h1>Personalized nutrition</h1>
        <h2>Get healthy and delicious recipes for every meal, tailored to your goals and dietary needs.</h2>
      </div>
    </div>
    <div className="slide slide-3">
      <div className="slide-copy">
        <h1>Sleep suggestions</h1>
        <h2>Enjoy customized sleep tips to help you snooze sweeter each night.</h2>
      </div>
    </div>
    <div className="slide slide-4">
      <div className="slide-copy">
        <h1>Free wearable</h1>
        <h2>Get iFit Coach for 1-year and you'll receive a free iFit fitness tracker.</h2>
        <p className="slide-disclaimer">*Offer only valid in the U.S.</p>
      </div>
    </div>
  </NukaCarousel>
);

MarketingCarousel.propTypes = {
  onBack: PropTypes.func
};

export default MarketingCarousel;
